export const carouselContainer = {
  height: "100%",
  position: "relative",
};

export const carouselScrollContainer = ({ disableScroll }) => ({
  height: "100%",
  overflowX: disableScroll ? "hidden" : "auto",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
});

export const carouselMedia = {
  height: "100%",
  display: "flex",
};

export const carouselItem = {
  height: "100%",
  width: "100%",
  flexShrink: "0",
  scrollSnapAlign: "center",
  position: "relative",

  "&:first-of-type": {
    scrollSnapAlign: "start",
  },

  "&:last-of-type": {
    scrollSnapAlign: "end",
  },
};

export const displayImage = {
  height: "100%",
  width: "100%",
  minWidth: "100%",
  display: "block",
  objectFit: "cover",
  objectPosition: "center",
};

export const cornerTag = {
  padding: "10px 22px 10px 20px",
  position: "absolute",
  top: "50px",
  right: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  backgroundColor: "black",
  color: "white",
  border: "1px solid white",
  borderWidth: "2px 0 2px 2px",
  borderRadius: "8px 0 0 8px",
};

export const cornerTagText = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "15px",
  lineHeight: "15px",
  letterSpacing: "0.1em",
  textTransform: "uppercase",
};

export const cornerText = ({ textColor = "white" }) => ({
  fontWeight: "300",
  color: textColor,
  textTransform: "uppercase",
  position: "absolute",
  top: "55px",
  left: "50px",
});

export const cornerTagImg = {
  width: "125px",
};

export const paginationDots = {
  position: "absolute",
  bottom: "50px",
  left: "50px",
  display: "flex",
  gap: "10px",
};

export const paginationDot = ({
  isSelected,
  textColor = "white",
  dotColor,
}) => ({
  width: "20px",
  height: "20px",
  border: "2px solid",
  borderColor: textColor,
  borderRadius: "50%",
  backgroundColor: isSelected ? textColor : dotColor,
});
